import { LockClosedIcon } from '@heroicons/react/24/solid';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { useWebThemeContext } from '../Layout/Context/useWebThemeContext';
import Typography from '../Typography';

interface Props {
  color: string;
  bgColor: string;
  fontFamily: string;
}

const PostPremiumBadge = ({ color, fontFamily, bgColor }: Props) => {
  const { t } = useTranslation();
  const { classes } = useWebThemeContext();

  return (
    <div
      className={cx(classes.radius, 'flex w-fit items-center space-x-1 rounded px-2 py-1')}
      style={{
        backgroundColor: bgColor,
      }}
    >
      <LockClosedIcon
        style={{
          color: color,
        }}
        className="h-3 w-3"
      />
      <Typography as="span" size={'sm'} fontFamily={fontFamily} fontFamilyv2={fontFamily} weight="light" color={color}>
        {t('posts.premium')}
      </Typography>
    </div>
  );
};

export default PostPremiumBadge;
